import { toDomId } from "../shared.ts";
import type { RenderContext, RenderField } from "../types.ts";

/**
 * Renders a HIDDEN field as a bare `input[type=hidden]` with no field wrapper.
 *
 * Hidden fields carry an untrusted, non-interactive value seeded from an
 * optional configured default. They are placed at the top of the form exactly
 * once and never contribute a label, help text, or layout scaffold.
 */
export const renderHiddenField = (
  field: RenderField<"HIDDEN">,
  context: RenderContext,
): HTMLElement => {
  const input = document.createElement("input");
  input.type = "hidden";
  input.id = `${context.instanceId}-${toDomId(field.id)}`;
  input.name = field.key;
  input.dataset.fieldId = field.id;
  input.dataset.fieldType = field.type;

  if (field.configJson) {
    input.value = field.configJson.defaultValue;
  }

  return input;
};
